import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { Factura } from '../models/factura.interface';
import { FacturaProductos } from '../models/factura-productos.interface';
import { LoaderService } from '../shared/loader/services/loader.service';
@Injectable({ providedIn: 'root' })
export class FacturaService {


    constructor(private http: HttpClient, private loaderService: LoaderService) { }

    createFacturaProductos(factura: FacturaProductos): Observable<HttpRespuesta<FacturaProductos>> {
        this.loaderService.activar();
        return this.http.post<HttpRespuesta<FacturaProductos>>(environment.api.factura_productos, factura).pipe(finalize(() => this.loaderService.desactivar()));
    }

    catFactura(id: number): Observable<Factura[]> {
        this.loaderService.activar();
        return this.http.get<Factura[]>(environment.api.distribuidor.facturas + id).pipe(finalize(() => this.loaderService.desactivar()));
    }
    catTipoProducto():
        Observable<Factura[]> {
        this.loaderService.activar();
        return this.http.get<Factura[]>(environment.api.distribuidor.facturas).pipe(finalize(() => this.loaderService.desactivar()));
    }
    empresas():
        Observable<Factura[]> {
        this.loaderService.activar();
        return this.http.get<Factura[]>(environment.api.distribuidor.facturas).pipe(finalize(() => this.loaderService.desactivar()));
    }
}
